import { type FC } from 'react';

import { Button, ButtonProps } from '@/components/shadcn/ui/button';
import { cn } from '@/utils';

import { useLtcWallet } from '../../hooks';

import { ConnectedLtcWalletButton } from './components';

export const ConnectedLtcWallet: FC<ButtonProps> = ({ className, children, ...props }) => {
  const { connect, isConnected } = useLtcWallet();

  if (!isConnected) {
    return (
      <Button
        variant="secondary"
        size="sm"
        className={cn('font-cocogoose rounded-xl text-sm font-bold', className)}
        onClick={() => {
          void connect();
        }}
        {...props}
      >
        {children || 'Connect LTC Wallet'}
      </Button>
    );
  }

  return (
    <ConnectedLtcWalletButton {...props} className={className}>
      {children}
    </ConnectedLtcWalletButton>
  );
};
